// Import model
import { StartProjectAssignContactRequest } from '../models/StartProjectAssignContactRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAssignContactRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAssignContactRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAssignContactRequest instance
   */
  static deserialize(json: string): StartProjectAssignContactRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAssignContactRequest instance
   */
  static fromObject(obj: any): StartProjectAssignContactRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAssignContactRequest');
    }


    const instance: StartProjectAssignContactRequest = {
      contactId: obj['ContactId'] as string | undefined,
      role: obj['Role'] as string | undefined,
      parentObjectType: obj['ParentObjectType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAssignContactRequest instances
   */
  static deserializeArray(json: string): StartProjectAssignContactRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAssignContactRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAssignContactRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAssignContactRequest instance to a plain object
   */
  static toObject(instance: StartProjectAssignContactRequest): any {
    return {
      'ContactId': instance.contactId,
      'Role': instance.role,
      'ParentObjectType': instance.parentObjectType,
    };
  }

  /**
   * Serializes an array of StartProjectAssignContactRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAssignContactRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
